module.exports = __webpack_public_path__ + "static/media/BuenosAiresWeb-SemiBold.01b6dc52.woff";